import React from 'react'
import { IconProps } from '../../types'
import './icon-component.scss'
import { concatClassName } from '../../utils/helpers'

const BookmarkIcon = ({
  type = 'default',
  height = '18px',
  width = '14px',
  classes,
}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 14 18'
      fill='none'
      className={concatClassName(classes)}
    >
      <path
        d='M2 14.95L7 12.8L12 14.95V2H2V14.95ZM0 18V2C0 1.45 0.196 0.979 0.588 0.587C0.979333 0.195667 1.45 0 2 0H12C12.55 0 13.021 0.195667 13.413 0.587C13.8043 0.979 14 1.45 14 2V18L7 15L0 18Z'
        className={type}
      />
    </svg>
  )
}

const CheckCircleIcon = ({
  type = 'success',
  width = '18px',
  height = '18px',
  classes,
  dataTestId,
}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      className={concatClassName(classes)}
      data-testid={dataTestId}
    >
      <path
        d='M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0 12.6833 0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025 17.075 2.925C17.975 3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM10 18C12.2167 18 14.1043 17.221 15.663 15.663C17.221 14.1043 18 12.2167 18 10C18 7.78333 17.221 5.89567 15.663 4.337C14.1043 2.779 12.2167 2 10 2C7.78333 2 5.896 2.779 4.338 4.337C2.77933 5.89567 2 7.78333 2 10C2 12.2167 2.77933 14.1043 4.338 15.663C5.896 17.221 7.78333 18 10 18Z'
        className={type}
      />
    </svg>
  )
}

const Hamburger = ({ type = 'default', width = '32px', height = '32px' }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns='http://www.w3.org/2000/svg'
      fill='#000000'
      viewBox='0 0 24 24'
    >
      <path
        d='M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z'
        className={type}
      />
    </svg>
  )
}

const DeniedIcon = () => {
  return (
    <svg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20 44H60V36H20V44ZM40 80C34.4667 80 29.2667 78.9493 24.4 76.848C19.5333 74.7493 15.3 71.9 11.7 68.3C8.1 64.7 5.25067 60.4667 3.152 55.6C1.05067 50.7333 0 45.5333 0 40C0 34.4667 1.05067 29.2667 3.152 24.4C5.25067 19.5333 8.1 15.3 11.7 11.7C15.3 8.1 19.5333 5.24933 24.4 3.148C29.2667 1.04933 34.4667 0 40 0C45.5333 0 50.7333 1.04933 55.6 3.148C60.4667 5.24933 64.7 8.1 68.3 11.7C71.9 15.3 74.7493 19.5333 76.848 24.4C78.9493 29.2667 80 34.4667 80 40C80 45.5333 78.9493 50.7333 76.848 55.6C74.7493 60.4667 71.9 64.7 68.3 68.3C64.7 71.9 60.4667 74.7493 55.6 76.848C50.7333 78.9493 45.5333 80 40 80ZM40 72C48.9333 72 56.5 68.9 62.7 62.7C68.9 56.5 72 48.9333 72 40C72 31.0667 68.9 23.5 62.7 17.3C56.5 11.1 48.9333 8 40 8C31.0667 8 23.5 11.1 17.3 17.3C11.1 23.5 8 31.0667 8 40C8 48.9333 11.1 56.5 17.3 62.7C23.5 68.9 31.0667 72 40 72Z'
        fill='#DD0000'
      />
    </svg>
  )
}

const Close = ({
  type = 'default',
  width = '32px',
  height = '32px',
  onClick,
  classes,
  dataTestId,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns='http://www.w3.org/2000/svg'
      onClick={onClick}
      className={concatClassName(classes)}
      fill='#000000'
      viewBox='0 0 24 24'
      data-testid={dataTestId}
    >
      <path
        d='M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z'
        className={type}
      />
    </svg>
  )
}
const ReportIcon = ({
  type = 'error',
  width = '18px',
  height = '18px',
  classes,
  dataTestId,
}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
      className={concatClassName(classes)}
      data-testid={dataTestId}
    >
      <path
        d='M5.25 18L0 12.75V5.25L5.25 0H12.75L18 5.25V12.75L12.75 18H5.25ZM9 14C9.28333 14 9.521 13.904 9.713 13.712C9.90433 13.5207 10 13.2833 10 13C10 12.7167 9.90433 12.479 9.713 12.287C9.521 12.0957 9.28333 12 9 12C8.71667 12 8.47933 12.0957 8.288 12.287C8.096 12.479 8 12.7167 8 13C8 13.2833 8.096 13.5207 8.288 13.712C8.47933 13.904 8.71667 14 9 14ZM8 10H10V4H8V10ZM6.1 16H11.9L16 11.9V6.1L11.9 2H6.1L2 6.1V11.9L6.1 16Z'
        className={type}
      />
    </svg>
  )
}

const WarningIcon = ({ type = 'warning-banner', width = '22px', height = '19px' }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox={'0 0 22 19'}
      fill='none'
    >
      <path
        d='M11 14.2441H11.01'
        className={type}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11 6.73242V10.4888'
        className={type}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.36333 1.9041L1.25653 15.1827C1.08938 15.4667 1.00094 15.7887 1.00001 16.1167C0.999072 16.4446 1.08567 16.7671 1.25119 17.052C1.41671 17.3369 1.65538 17.5744 1.94346 17.7407C2.23153 17.907 2.55897 17.9964 2.8932 18H19.1068C19.441 17.9964 19.7685 17.907 20.0565 17.7407C20.3446 17.5744 20.5833 17.3369 20.7488 17.052C20.9143 16.7671 21.0009 16.4446 21 16.1167C20.9991 15.7887 20.9106 15.4667 20.7435 15.1827L12.6367 1.9041C12.466 1.62811 12.2258 1.39992 11.9391 1.24156C11.6524 1.0832 11.329 1 11 1C10.671 1 10.3476 1.0832 10.0609 1.24156C9.7742 1.39992 9.53395 1.62811 9.36333 1.9041V1.9041Z'
        className={type}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

const GoogleIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='40px'
      height='40px'
      viewBox='0 0 41 40'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30.5375 20.2271C30.5375 19.518 30.4739 18.8362 30.3557 18.1816H20.9375V22.0498H26.3193C26.0875 23.2998 25.383 24.3589 24.3239 25.068V27.5771H27.5557C29.4466 25.8362 30.5375 23.2726 30.5375 20.2271Z'
        fill='#4285F4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.9364 30.0004C23.6364 30.0004 25.9 29.105 27.5546 27.5777L24.3228 25.0686C23.4273 25.6686 22.2818 26.0231 20.9364 26.0231C18.3318 26.0231 16.1273 24.264 15.3409 21.9004H12V24.4913C13.6455 27.7595 17.0273 30.0004 20.9364 30.0004Z'
        fill='#34A853'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.3421 21.9007C15.1421 21.3007 15.0284 20.6598 15.0284 20.0007C15.0284 19.3416 15.1421 18.7007 15.3421 18.1007V15.5098H12.0011C11.3239 16.8598 10.9375 18.387 10.9375 20.0007C10.9375 21.6143 11.3239 23.1416 12.0011 24.4916L15.3421 21.9007Z'
        fill='#FBBC05'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.9374 13.9773C22.4055 13.9773 23.7237 14.4818 24.7601 15.4727L27.6283 12.6046C25.8965 10.9909 23.6328 10 20.9374 10C17.0283 10 13.6464 12.2409 12.001 15.5091L15.3419 18.1C16.1283 15.7364 18.3328 13.9773 20.9374 13.9773Z'
        fill='#EA4335'
      />
    </svg>
  )
}

const ForwardInboxIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='84' height='76' viewBox='0 0 84 76' fill='none'>
      <path
        d='M40 36L8 16V56H44V64H8C5.8 64 3.91733 63.2173 2.352 61.652C0.784 60.084 0 58.2 0 56V8C0 5.8 0.784 3.91733 2.352 2.352C3.91733 0.783999 5.8 0 8 0H72C74.2 0 76.084 0.783999 77.652 2.352C79.2173 3.91733 80 5.8 80 8V36H72V16L40 36ZM40 28L72 8H8L40 28ZM68 76L62.4 70.4L68.7 64H52V56H68.7L62.3 49.6L68 44L84 60L68 76ZM8 16V60V36V36.3V8V16Z'
        fill='#C0C0C0'
      />
    </svg>
  )
}

const MarkEmailReadIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='84' height='72' viewBox='0 0 84 72' fill='none'>
      <path
        d='M55.8 72L38.8 55L44.4 49.4L55.8 60.8L78.4 38.2L84 43.8L55.8 72ZM40 28L72 8H8L40 28ZM40 36L8 16V56H28.6L36.6 64H8C5.8 64 3.91733 63.2173 2.352 61.652C0.784 60.084 0 58.2 0 56V8C0 5.8 0.784 3.91733 2.352 2.352C3.91733 0.783999 5.8 0 8 0H72C74.2 0 76.084 0.783999 77.652 2.352C79.2173 3.91733 80 5.8 80 8V25.4L72 33.4V16L40 36Z'
        fill='#48B767'
      />
    </svg>
  )
}

const LockResetIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='85' height='72' viewBox='0 0 85 72' fill='none'>
      <path
        d='M49 72C44.0667 72 39.4507 71.0827 35.152 69.248C30.8507 67.416 27.0667 64.9 23.8 61.7L29.5 56C32.0333 58.4667 34.9667 60.416 38.3 61.848C41.6333 63.2827 45.2 64 49 64C56.7333 64 63.3333 61.2667 68.8 55.8C74.2667 50.3333 77 43.7333 77 36C77 28.2667 74.2667 21.6667 68.8 16.2C63.3333 10.7333 56.7333 8 49 8C41.2667 8 34.6667 10.7333 29.2 16.2C23.7333 21.6667 21 28.2667 21 36V36.7L28.3 29.4L34 35L17 52L0 35L5.7 29.4L13 36.8V36C13 31 13.9507 26.316 15.852 21.948C17.7507 17.5827 20.3173 13.7827 23.552 10.548C26.784 7.316 30.584 4.74933 34.952 2.848C39.3173 0.949333 44 0 49 0C54 0 58.684 0.949333 63.052 2.848C67.4173 4.74933 71.2173 7.316 74.452 10.548C77.684 13.7827 80.2507 17.5827 82.152 21.948C84.0507 26.316 85 31 85 36C85 46 81.5 54.5 74.5 61.5C67.5 68.5 59 72 49 72ZM41 52C39.8667 52 38.9173 51.616 38.152 50.848C37.384 50.0827 37 49.1333 37 48V36C37 34.8667 37.384 33.916 38.152 33.148C38.9173 32.3827 39.8667 32 41 32V28C41 25.8 41.784 23.916 43.352 22.348C44.9173 20.7827 46.8 20 49 20C51.2 20 53.084 20.7827 54.652 22.348C56.2173 23.916 57 25.8 57 28V32C58.1333 32 59.084 32.3827 59.852 33.148C60.6173 33.916 61 34.8667 61 36V48C61 49.1333 60.6173 50.0827 59.852 50.848C59.084 51.616 58.1333 52 57 52H41ZM45 32H53V28C53 26.8667 52.6173 25.916 51.852 25.148C51.084 24.3827 50.1333 24 49 24C47.8667 24 46.9173 24.3827 46.152 25.148C45.384 25.916 45 26.8667 45 28V32Z'
        fill='#C0C0C0'
      />
    </svg>
  )
}

const SyncLockResetIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='68' height='72' viewBox='0 0 68 72' fill='none'>
      <path
        d='M0 64V56H10.9C7.5 53.0667 4.83333 49.5333 2.9 45.4C0.966666 41.2667 0 36.8 0 32C0 24.5333 2.26667 17.9493 6.8 12.248C11.3333 6.54933 17.0667 2.8 24 1V9.4C19.3333 11.0667 15.5 13.9493 12.5 18.048C9.5 22.1493 8 26.8 8 32C8 35.6 8.716 38.9173 10.148 41.952C11.5827 44.984 13.5333 47.6 16 49.8V40H24V64H0ZM56 32C56 28.6 55.3173 25.4173 53.952 22.452C52.584 19.484 50.6 16.7333 48 14.2V24H40V0H64V8H53.1C57.0333 11.5333 59.8173 15.316 61.452 19.348C63.084 23.3827 63.9333 27.6 64 32H56ZM48 72C46.8667 72 45.9173 71.616 45.152 70.848C44.384 70.0827 44 69.1333 44 68V56C44 54.8667 44.384 53.9173 45.152 53.152C45.9173 52.384 46.8667 52 48 52V48C48 45.8 48.7827 43.916 50.348 42.348C51.916 40.7827 53.8 40 56 40C58.2 40 60.084 40.7827 61.652 42.348C63.2173 43.916 64 45.8 64 48V52C65.1333 52 66.0827 52.384 66.848 53.152C67.616 53.9173 68 54.8667 68 56V68C68 69.1333 67.616 70.0827 66.848 70.848C66.0827 71.616 65.1333 72 64 72H48ZM52 52H60V48C60 46.8667 59.616 45.916 58.848 45.148C58.0827 44.3827 57.1333 44 56 44C54.8667 44 53.9173 44.3827 53.152 45.148C52.384 45.916 52 46.8667 52 48V52Z'
        fill='#C0C0C0'
      />
    </svg>
  )
}

const ArrowBackIcon = ({
  type = 'default',
  height = '16px',
  width = '16px',
  classes,
}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16 16'
      className={`${type} ${concatClassName(classes)}`}
    >
      <path d='M8 16L0 8L8 0L9.425 1.4L3.825 7H16V9H3.825L9.425 14.6L8 16Z' fill='#2C3941' />
    </svg>
  )
}
const EyeIcon = ({
  type = 'default',
  height = '16px',
  width = '16px',
  classes,
  onClick,
  dataTestId,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      onClick={onClick}
      className={`${type} ${concatClassName(classes)}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid={dataTestId}
    >
      <path
        d='M11 12C12.25 12 13.3127 11.5627 14.188 10.688C15.0627 9.81267 15.5 8.75 15.5 7.5C15.5 6.25 15.0627 5.18733 14.188 4.312C13.3127 3.43733 12.25 3 11 3C9.75 3 8.68733 3.43733 7.812 4.312C6.93733 5.18733 6.5 6.25 6.5 7.5C6.5 8.75 6.93733 9.81267 7.812 10.688C8.68733 11.5627 9.75 12 11 12ZM11 10.2C10.25 10.2 9.61267 9.93733 9.088 9.412C8.56267 8.88733 8.3 8.25 8.3 7.5C8.3 6.75 8.56267 6.11233 9.088 5.587C9.61267 5.06233 10.25 4.8 11 4.8C11.75 4.8 12.3877 5.06233 12.913 5.587C13.4377 6.11233 13.7 6.75 13.7 7.5C13.7 8.25 13.4377 8.88733 12.913 9.412C12.3877 9.93733 11.75 10.2 11 10.2ZM11 15C8.56667 15 6.35 14.3207 4.35 12.962C2.35 11.604 0.9 9.78333 0 7.5C0.9 5.21667 2.35 3.39567 4.35 2.037C6.35 0.679 8.56667 0 11 0C13.4333 0 15.65 0.679 17.65 2.037C19.65 3.39567 21.1 5.21667 22 7.5C21.1 9.78333 19.65 11.604 17.65 12.962C15.65 14.3207 13.4333 15 11 15ZM11 13C12.8833 13 14.6127 12.504 16.188 11.512C17.7627 10.5207 18.9667 9.18333 19.8 7.5C18.9667 5.81667 17.7627 4.479 16.188 3.487C14.6127 2.49567 12.8833 2 11 2C9.11667 2 7.38733 2.49567 5.812 3.487C4.23733 4.479 3.03333 5.81667 2.2 7.5C3.03333 9.18333 4.23733 10.5207 5.812 11.512C7.38733 12.504 9.11667 13 11 13Z'
        fill='#545A5E'
      />
    </svg>
  )
}
const SlashedEyeIcon = ({
  type = 'default',
  height = '16px',
  width = '16px',
  classes,
  onClick,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      onClick={onClick}
      className={`${type} ${concatClassName(classes)}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.1 11.2998L13.65 9.8498C13.8 9.06647 13.575 8.33314 12.975 7.6498C12.375 6.96647 11.6 6.6998 10.65 6.8498L9.2 5.39981C9.48333 5.26647 9.77067 5.16647 10.062 5.0998C10.354 5.03314 10.6667 4.9998 11 4.9998C12.25 4.9998 13.3127 5.43714 14.188 6.3118C15.0627 7.18714 15.5 8.2498 15.5 9.4998C15.5 9.83314 15.4667 10.1458 15.4 10.4378C15.3333 10.7291 15.2333 11.0165 15.1 11.2998ZM18.3 14.4498L16.85 13.0498C17.4833 12.5665 18.046 12.0371 18.538 11.4618C19.0293 10.8871 19.45 10.2331 19.8 9.4998C18.9667 7.81647 17.7707 6.4788 16.212 5.4868C14.654 4.49547 12.9167 3.9998 11 3.9998C10.5167 3.9998 10.0417 4.03314 9.575 4.0998C9.10833 4.16647 8.65 4.26647 8.2 4.3998L6.65 2.8498C7.33333 2.56647 8.03333 2.3538 8.75 2.2118C9.46667 2.07047 10.2167 1.9998 11 1.9998C13.5167 1.9998 15.7583 2.69547 17.725 4.0868C19.6917 5.4788 21.1167 7.28314 22 9.4998C21.6167 10.4831 21.1127 11.3958 20.488 12.2378C19.8627 13.0791 19.1333 13.8165 18.3 14.4498ZM18.8 20.5998L14.6 16.4498C14.0167 16.6331 13.4293 16.7708 12.838 16.8628C12.246 16.9541 11.6333 16.9998 11 16.9998C8.48333 16.9998 6.24167 16.3041 4.275 14.9128C2.30833 13.5208 0.883333 11.7165 0 9.4998C0.35 8.61647 0.791667 7.79547 1.325 7.0368C1.85833 6.2788 2.46667 5.5998 3.15 4.9998L0.4 2.1998L1.8 0.799805L20.2 19.1998L18.8 20.5998ZM4.55 6.3998C4.06667 6.83314 3.625 7.30814 3.225 7.8248C2.825 8.34147 2.48333 8.8998 2.2 9.4998C3.03333 11.1831 4.229 12.5205 5.787 13.5118C7.34567 14.5038 9.08333 14.9998 11 14.9998C11.3333 14.9998 11.6583 14.9791 11.975 14.9378C12.2917 14.8958 12.6167 14.8498 12.95 14.7998L12.05 13.8498C11.8667 13.8998 11.6917 13.9371 11.525 13.9618C11.3583 13.9871 11.1833 13.9998 11 13.9998C9.75 13.9998 8.68733 13.5625 7.812 12.6878C6.93733 11.8125 6.5 10.7498 6.5 9.4998C6.5 9.31647 6.51233 9.14147 6.537 8.9748C6.56233 8.80814 6.6 8.63314 6.65 8.4498L4.55 6.3998Z'
        fill='#545A5E'
      />
    </svg>
  )
}

const PreviousArrow = () => {
  return (
    <svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M6 12L0 6L6 0L7.4 1.4L2.8 6L7.4 10.6L6 12Z' fill='#545A5E' />
    </svg>
  )
}

const NextArrow = () => {
  return (
    <svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1.4 12L0 10.6L4.6 6L0 1.4L1.4 0L7.4 6L1.4 12Z' fill='#545A5E' />
    </svg>
  )
}

const CBLogoV2 = ({ type = 'default', width = '90', height = '80', classes }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={`${type} ${concatClassName(classes)}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 6.44 184.02 38.97'
    >
      <path
        d='M46.315 45.4152C44.7235 45.4152 43.3656 45.0605 42.2412 44.3513C41.1341 43.6248 40.2865 42.6388 39.6984 41.3933C39.1275 40.1478 38.8421 38.738 38.8421 37.1638V14.6932C38.8421 13.1363 39.1362 11.7352 39.7243 10.4897C40.3298 9.24419 41.1947 8.25818 42.3191 7.53165C43.4435 6.80512 44.7754 6.44185 46.315 6.44185C47.474 6.44185 48.5119 6.65808 49.4287 7.09054C50.3455 7.523 51.124 8.1198 51.764 8.88093C52.4213 9.62476 52.923 10.4983 53.269 11.5016C53.6149 12.4876 53.7879 13.5515 53.7879 14.6932V19.9346H48.5465V14.6932C48.5465 13.8975 48.3822 13.2315 48.0535 12.6952C47.7248 12.159 47.1799 11.8909 46.4188 11.8909C45.7269 11.8909 45.2252 12.1676 44.9138 12.7212C44.6025 13.2747 44.4468 13.9321 44.4468 14.6932V37.1638C44.4468 37.925 44.6111 38.5823 44.9398 39.1358C45.2857 39.6894 45.7788 39.9662 46.4188 39.9662C47.1972 39.9662 47.7421 39.698 48.0535 39.1618C48.3822 38.6255 48.5465 37.9595 48.5465 37.1638V31.9224H53.7879V37.1638C53.7879 38.7207 53.4852 40.1218 52.8797 41.3673C52.2743 42.6128 51.4094 43.5988 50.285 44.3254C49.1779 45.0519 47.8546 45.4152 46.315 45.4152ZM57.7007 45V6.85701H63.3054C66.6613 6.85701 69.135 7.79113 70.7264 9.65935C72.3179 11.5103 73.1136 14.2434 73.1136 17.8588C73.1136 20.0038 72.733 21.8634 71.9719 23.4375C71.2281 24.9944 70.3199 26.1361 69.2474 26.8626L73.0617 45H67.457L64.2914 28.9125H63.3054V45H57.7007ZM63.3054 23.723C64.3433 23.723 65.165 23.4981 65.7704 23.0483C66.3759 22.5813 66.8083 21.9239 67.0678 21.0763C67.3273 20.2287 67.457 19.2254 67.457 18.0664C67.457 16.25 67.1543 14.8575 66.5489 13.8888C65.9607 12.9028 64.8796 12.4098 63.3054 12.4098V23.723ZM76.2492 45V6.85701H89.0673V12.6174H81.8539V22.8926H87.0434V28.4973H81.8539V39.2396H89.0673V45H76.2492ZM93.2267 45V6.85701H98.9351C100.734 6.85701 102.256 7.15109 103.502 7.73923C104.747 8.32738 105.751 9.33069 106.512 10.7492C107.273 12.1676 107.818 14.1137 108.147 16.5874C108.493 19.061 108.665 22.1834 108.665 25.9545C108.665 29.7428 108.493 32.8738 108.147 35.3475C107.818 37.8039 107.273 39.7413 106.512 41.1598C105.751 42.5609 104.747 43.5556 103.502 44.1437C102.256 44.7146 100.734 45 98.9351 45H93.2267ZM98.8313 39.3953C100.215 39.3953 101.193 38.8504 101.763 37.7606C102.334 36.6708 102.68 35.114 102.801 33.09C102.922 31.0661 102.983 28.6617 102.983 25.8766C102.983 23.057 102.922 20.6525 102.801 18.6632C102.68 16.6566 102.326 15.1257 101.737 14.0704C101.167 12.9979 100.198 12.4617 98.8313 12.4617V39.3953ZM112.535 45V6.85701H118.14V45H112.535ZM122.316 45V6.85701H128.025C129.962 6.85701 131.632 7.20298 133.033 7.89492C134.451 8.56956 135.541 9.63341 136.302 11.0865C137.081 12.5395 137.47 14.4164 137.47 16.7171C137.47 18.5507 137.228 20.1508 136.743 21.5174C136.276 22.884 135.359 23.9997 133.993 24.8647C135.377 25.6258 136.371 26.8367 136.977 28.4973C137.582 30.1407 137.885 32.0435 137.885 34.2058C137.885 36.3335 137.539 38.2104 136.847 39.8364C136.172 41.4625 135.169 42.7339 133.837 43.6507C132.522 44.5502 130.896 45 128.959 45H122.316ZM127.921 39.4472C129.616 39.4472 130.732 38.9456 131.268 37.9422C131.805 36.9216 132.073 35.4686 132.073 33.5831C132.073 31.6629 131.805 30.2099 131.268 29.2239C130.732 28.2205 129.616 27.7189 127.921 27.7189V39.4472ZM127.921 22.5813C129.495 22.5813 130.576 22.1488 131.164 21.2839C131.77 20.419 132.073 19.1389 132.073 17.4436C132.073 15.7311 131.761 14.4683 131.139 13.6553C130.533 12.825 129.461 12.4098 127.921 12.4098V22.5813ZM141.22 45V6.85701H146.824V45H141.22ZM151.001 45V6.85701H156.605V39.8105H164.026V45H151.001ZM165.645 45L171.405 6.85701H178.255L184.016 45H178.567L177.529 37.2157H172.132L171.094 45H165.645ZM172.91 31.2997H176.75L175.142 18.4815L174.986 16.4576H174.675L174.519 18.4815L172.91 31.2997Z'
        fill='#0F4F99'
      ></path>
      <path
        d='M24.3 44.7683C27.0004 38.8334 28.298 32.3564 28.0923 25.8393C27.8866 19.3223 26.1831 12.94 23.1138 7.18726L0 19.5192C1.17602 21.7234 1.82872 24.1688 1.90754 26.6659C1.98636 29.1629 1.48918 31.6446 0.454513 33.9186L24.3 44.7683Z'
        fill='#CAA566'
      ></path>
    </svg>
  )
}

const FileUploadIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='22' height='28' viewBox='0 0 25 30' fill='none'>
      <path
        d='M8.43262 19.1992H16.8783'
        stroke='#545A5E'
        strokeOpacity='0.7'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.6553 23.4V15'
        stroke='#545A5E'
        strokeOpacity='0.7'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.4707 1V9.4H23.9164'
        stroke='#545A5E'
        strokeOpacity='0.7'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.4706 1H4.20975C3.46311 1 2.74704 1.295 2.21909 1.8201C1.69113 2.3452 1.39453 3.05739 1.39453 3.8V26.2C1.39453 26.9426 1.69113 27.6548 2.21909 28.1799C2.74704 28.705 3.46311 29 4.20975 29H21.101C21.8477 29 22.5637 28.705 23.0917 28.1799C23.6197 27.6548 23.9163 26.9426 23.9163 26.2V9.4L15.4706 1Z'
        stroke='#545A5E'
        strokeOpacity='0.7'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

const LeftArrowIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='8' height='12' viewBox='0 0 6 10' fill='none'>
      <path
        d='M5 9L1 5L5 1'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

const FileUploadedIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='22' height='28' viewBox='0 0 24 24' fill='none'>
      <path
        d='M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z'
        stroke='#545A5E'
        strokeOpacity='0.7'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14 2V8H20'
        stroke='#545A5E'
        strokeOpacity='0.7'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

const LinkIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
      <path
        d='M7.00578 5.49564C6.78983 5.20664 6.51432 4.96751 6.19793 4.79447C5.88154 4.62144 5.53168 4.51854 5.17207 4.49276C4.81247 4.46698 4.45153 4.51892 4.11373 4.64505C3.77594 4.77119 3.4692 4.96858 3.21432 5.22382L1.70578 6.73393C1.24779 7.20861 0.994367 7.84437 1.0001 8.50428C1.00582 9.16419 1.27024 9.79545 1.7364 10.2621C2.20256 10.7287 2.83316 10.9934 3.49239 10.9992C4.15161 11.0049 4.78671 10.7512 5.2609 10.2928L6.12077 9.43199'
        stroke='#2C3941'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.99414 6.50362C5.21009 6.79262 5.4856 7.03175 5.80199 7.20478C6.11838 7.37782 6.46824 7.48072 6.82785 7.5065C7.18745 7.53228 7.54839 7.48034 7.88619 7.3542C8.22398 7.22807 8.53072 7.03068 8.7856 6.77544L10.2941 5.26533C10.7521 4.79065 11.0056 4.15489 10.9998 3.49498C10.9941 2.83507 10.7297 2.20381 10.2635 1.73717C9.79736 1.27052 9.16676 1.00583 8.50753 1.0001C7.84831 0.994361 7.21321 1.24804 6.73902 1.70651L5.87412 2.56727'
        stroke='#2C3941'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

const LocationIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='10' height='12' viewBox='0 0 10 12' fill='none'>
      <path
        d='M5.00008 6.45384C5.73646 6.45384 6.33341 5.84331 6.33341 5.0902C6.33341 4.33708 5.73646 3.72656 5.00008 3.72656C4.2637 3.72656 3.66675 4.33708 3.66675 5.0902C3.66675 5.84331 4.2637 6.45384 5.00008 6.45384Z'
        stroke='#2C3941'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9 5.09091C9 8.27273 5 11 5 11C5 11 1 8.27273 1 5.09091C1 4.00593 1.42143 2.96539 2.17157 2.1982C2.92172 1.43101 3.93913 1 5 1C6.06087 1 7.07828 1.43101 7.82843 2.1982C8.57857 2.96539 9 4.00593 9 5.09091Z'
        stroke='#2C3941'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

const DeleteIcon = ({ height = '18', width = '14', onClick, classes, dataTestId }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      onClick={onClick}
      className={` ${concatClassName(classes)}`}
      viewBox='0 0 14 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid={dataTestId}
    >
      <path
        d='M3 16H11V6H3V16ZM0 3V1H3.5L4.5 0H9.5L10.5 1H14V3H0ZM3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.196 17.021 1 16.55 1 16V4H13V16C13 16.55 12.8043 17.021 12.413 17.413C12.021 17.8043 11.55 18 11 18H3Z'
        fill='#545A5E'
      />
    </svg>
  )
}

const SuccessIcon = ({ width = '18', height = '13', type = 'success' }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 13'
      fill='none'
    >
      <path
        d='M6.55001 12.9996L0.850006 7.29961L2.27501 5.87461L6.55001 10.1496L15.725 0.974609L17.15 2.39961L6.55001 12.9996Z'
        className={type}
      />
    </svg>
  )
}

const ErrorIcon = ({ width = '20', height = '20', type = 'error' }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M5 11H15V9H5V11ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0 12.6833 0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025 17.075 2.925C17.975 3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z'
        className={type}
      />
    </svg>
  )
}

const DownloadIcon = ({
  type = 'default',
  height = '16px',
  width = '16px',
  classes,
  onClick,
  dataTestId,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      onClick={onClick}
      className={`${type} ${concatClassName(classes)}`}
      viewBox='0 0 32 32'
      xmlns='http://www.w3.org/2000/svg'
      data-testid={dataTestId}
    >
      <path
        d='M31,22c-0.552,0-1,0.448-1,1v7H2v-7c0-0.552-0.448-1-1-1s-1,0.448-1,1v8c0,0.552,0.448,1,1,1h30   c0.552,0,1-0.448,1-1v-8C32,22.448,31.552,22,31,22z'
        className={type}
      />
      <path
        d='M15.27,23.707c0.389,0.385,1.04,0.389,1.429,0l6.999-6.9c0.395-0.391,0.394-1.024,0-1.414   c-0.394-0.391-1.034-0.391-1.428,0l-5.275,5.2V1c0-0.552-0.452-1-1.01-1c-0.558,0-1.01,0.448-1.01,1v19.593l-5.275-5.2   c-0.395-0.391-1.034-0.391-1.428,0c-0.395,0.391-0.395,1.024,0,1.414L15.27,23.707z'
        className={type}
      />
    </svg>
  )
}

const EditIcon = ({
  type = 'default',
  height = '48',
  width = '48',
  classes,
  onClick,
  dataTestId,
}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={height}
      width={width}
      onClick={onClick}
      className={`${type} ${concatClassName(classes)}`}
      viewBox='0 0 48 48'
      data-testid={dataTestId}
    >
      <path
        xmlns='http://www.w3.org/2000/svg'
        d='M9.35 39.05h1.6L32.7 17.2l-1.6-1.6L9.35 37.45Zm30.5-23.95-6.6-6.6 1.05-1.1q1.4-1.4 3.325-1.425Q39.55 5.95 40.95 7.3l.9.9q1.15 1.1 1.025 2.55-.125 1.45-1.125 2.45Zm-2.05 2.05L12.35 42.6h-6.6V36l25.4-25.4Zm-5.85-.75-.85-.8 1.6 1.6Z'
      />
    </svg>
  )
}

const ApprovedIcon = ({ width = '21', height = '21', type = 'success', classes }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 22 22'
      fill='none'
      className={concatClassName(classes)}
    >
      <path
        d='M7.6 21.5L5.7 18.3L2.1 17.5L2.45 13.8L0 11L2.45 8.2L2.1 4.5L5.7 3.7L7.6 0.5L11 1.95L14.4 0.5L16.3 3.7L19.9 4.5L19.55 8.2L22 11L19.55 13.8L19.9 17.5L16.3 18.3L14.4 21.5L11 20.05L7.6 21.5ZM9.95 14.55L15.6 8.9L14.2 7.45L9.95 11.7L7.8 9.6L6.4 11L9.95 14.55ZM8.45 18.95L11 17.85L13.6 18.95L15 16.55L17.75 15.9L17.5 13.1L19.35 11L17.5 8.85L17.75 6.05L15 5.45L13.55 3.05L11 4.15L8.4 3.05L7 5.45L4.25 6.05L4.5 8.85L2.65 11L4.5 13.1L4.25 15.95L7 16.55L8.45 18.95Z'
        className={type}
      />
    </svg>
  )
}

const PendingIcon = ({
  width = '18',
  height = '18',
  type = 'warning',
  classes,
  dataTestId,
}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
      className={concatClassName(classes)}
      data-testid={dataTestId}
    >
      <path
        d='M9 13.167C9.23612 13.167 9.43417 13.087 9.59417 12.927C9.75362 12.7675 9.83334 12.5698 9.83334 12.3337C9.83334 12.0975 9.75362 11.8995 9.59417 11.7395C9.43417 11.58 9.23612 11.5003 9 11.5003C8.76389 11.5003 8.56612 11.58 8.40667 11.7395C8.24667 11.8995 8.16667 12.0975 8.16667 12.3337C8.16667 12.5698 8.24667 12.7675 8.40667 12.927C8.56612 13.087 8.76389 13.167 9 13.167ZM8.16667 9.83366H9.83334V4.83366H8.16667V9.83366ZM9 17.3337C7.84723 17.3337 6.76389 17.1148 5.75001 16.677C4.73612 16.2398 3.85417 15.6462 3.10417 14.8962C2.35417 14.1462 1.76056 13.2642 1.32334 12.2503C0.885561 11.2364 0.666672 10.1531 0.666672 9.00033C0.666672 7.84755 0.885561 6.76421 1.32334 5.75033C1.76056 4.73644 2.35417 3.85449 3.10417 3.10449C3.85417 2.35449 4.73612 1.7606 5.75001 1.32283C6.76389 0.885603 7.84723 0.666992 9 0.666992C10.1528 0.666992 11.2361 0.885603 12.25 1.32283C13.2639 1.7606 14.1458 2.35449 14.8958 3.10449C15.6458 3.85449 16.2394 4.73644 16.6767 5.75033C17.1144 6.76421 17.3333 7.84755 17.3333 9.00033C17.3333 10.1531 17.1144 11.2364 16.6767 12.2503C16.2394 13.2642 15.6458 14.1462 14.8958 14.8962C14.1458 15.6462 13.2639 16.2398 12.25 16.677C11.2361 17.1148 10.1528 17.3337 9 17.3337ZM9 15.667C10.8611 15.667 12.4375 15.0212 13.7292 13.7295C15.0208 12.4378 15.6667 10.8614 15.6667 9.00033C15.6667 7.13921 15.0208 5.56283 13.7292 4.27116C12.4375 2.97949 10.8611 2.33366 9 2.33366C7.13889 2.33366 5.5625 2.97949 4.27084 4.27116C2.97917 5.56283 2.33334 7.13921 2.33334 9.00033C2.33334 10.8614 2.97917 12.4378 4.27084 13.7295C5.5625 15.0212 7.13889 15.667 9 15.667Z'
        className={type}
      />
    </svg>
  )
}

const InfoIcon = ({ width = '20', height = '20', classes }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={concatClassName(classes)}
    >
      <circle cx='9.79922' cy='9.6' r='9' stroke='black' strokeWidth='1.2' />
      <path
        d='M9.69161 8.136C9.37161 8.136 9.10761 8.036 8.89961 7.836C8.69961 7.628 8.59961 7.368 8.59961 7.056C8.59961 6.744 8.69961 6.492 8.89961 6.3C9.10761 6.1 9.37561 6 9.70361 6C10.0236 6 10.2836 6.1 10.4836 6.3C10.6836 6.492 10.7836 6.74 10.7836 7.044C10.7836 7.356 10.6796 7.616 10.4716 7.824C10.2716 8.032 10.0116 8.136 9.69161 8.136ZM9.52361 14.328C9.26761 14.328 9.05561 14.264 8.88761 14.136C8.71961 14.008 8.63961 13.836 8.64761 13.62L8.74361 9.192C8.75161 8.976 8.83561 8.808 8.99561 8.688C9.15561 8.56 9.36361 8.496 9.61961 8.496C9.88361 8.496 10.0996 8.56 10.2676 8.688C10.4356 8.816 10.5156 8.992 10.5076 9.216L10.4116 13.632C10.4036 13.848 10.3156 14.02 10.1476 14.148C9.98761 14.268 9.77961 14.328 9.52361 14.328Z'
        fill='black'
      />
    </svg>
  )
}
const ExternalLinkIcon = ({
  width = '20',
  height = '20',
  classes,
  onClick,
  dataTestId,
}: IconProps) => {
  return (
    <svg
      fill='none'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      onClick={onClick}
      className={concatClassName(classes)}
      data-testid={dataTestId}
    >
      <path
        d='M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14'
        stroke='#4A5568'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </svg>
  )
}

const ExpandMoreIcon = ({
  width = '12',
  height = '9',
  type = 'default-light',
  classes,
}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 12 9'
      fill='none'
      className={concatClassName(classes)}
    >
      <path
        d='M6 8.37461L0 2.37461L1.4 0.974609L6 5.57461L10.6 0.974609L12 2.37461L6 8.37461Z'
        className={type}
        fillOpacity='0.7'
      />
    </svg>
  )
}

export {
  BookmarkIcon,
  CheckCircleIcon,
  ReportIcon,
  GoogleIcon,
  DeniedIcon,
  ForwardInboxIcon,
  MarkEmailReadIcon,
  LockResetIcon,
  SyncLockResetIcon,
  LeftArrowIcon,
  LinkIcon,
  LocationIcon,
  SuccessIcon,
  ErrorIcon,
  EyeIcon,
  SlashedEyeIcon,
  Hamburger,
  Close,
  PreviousArrow,
  NextArrow,
  ArrowBackIcon,
  WarningIcon,
  CBLogoV2,
  FileUploadIcon,
  FileUploadedIcon,
  DeleteIcon,
  DownloadIcon,
  EditIcon,
  ApprovedIcon,
  PendingIcon,
  InfoIcon,
  ExternalLinkIcon,
  ExpandMoreIcon,
}
